class Result<T> {
    public value: T;
    public statusCode: number;
    public errors: { [id: string]: any };
    public errorMessage: string;
    public get hasErrors(): boolean {

        return (this.errors != null && this.errors != undefined)
            || (this.errorMessage && this.errorMessage.length > 0);
        /*return this.errors != null && this.errors != undefined
            && ((Array.isArray(this.errors) && this.errors.length > 0)
            || (this.errors != undefined && Object.keys(this.errors).length > 0));*/
    }

    constructor(value: T, errors: { [id: string]: any }, errorMessage: string, statusCode: number) {
        this.value = value;
        if (errors != null)
            this.errors = errors;//[0] == undefined || errors[0] == null ? [] : errors;

        this.errorMessage = errorMessage;
        this.statusCode = statusCode;
    }

    public static FromValue<T>(value: T) {
        return new Result(value, null, null, 200);
    }

    public static FromErrors(errors: { [id: string]: any }, errorMessage: string, statusCode: number) {
        return new Result(null, errors, errorMessage, statusCode);
    }
}

class PagedResult<T> {
    public Items: T[];
    public TotalItems: number;
}

export {
    Result,
    PagedResult
}
